import {buildQueryAndVariablesHash} from 'src/internal/revamp/queryUtils/queryAndVariablesHashing';

import type MemoryCache from 'src/internal/revamp/cache/MemoryCache';
import type ResultStore from 'src/internal/revamp/observable/ResultStore';
import type {
  GraphQlDocument,
  VariablesOfDoc,
} from 'src/internal/shared/graphql/types/document';

export default function shouldGoToNetwork<
  TDocumentNode extends GraphQlDocument<any, any, any, any>,
>(
  query: TDocumentNode,
  variables: VariablesOfDoc<TDocumentNode> | undefined,
  resultStore: ResultStore,
  memoryCache: MemoryCache,
): boolean {
  const {documentHashWithVariables} = buildQueryAndVariablesHash(
    query,
    variables,
  );
  const subQueryStaleness = resultStore.getStalenessState(
    documentHashWithVariables,
  );

  switch (subQueryStaleness) {
    case 'FRESH':
      const isInApolloCache =
        memoryCache.readQuery({
          query,
          variables,
        }) !== null;

      return !isInApolloCache;
    case 'NOT_FOUND':
    case 'STALE':
    default:
      return true;
  }
}
